import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { socialIconList } from './footer-data'
import Link from '@/components/Common/Link'

const SocialIconWrapper: React.FC<{
  children: ReactNode
  className?: string
  rest?: object
}> = ({ children, className = '', ...rest }) => {
  return (
    <div className={`h-7 w-7 cursor-pointer ${className}`} {...rest}>
      {children}
    </div>
  )
}

const SocialIconsV2 = () => {
  return (
    <div className="flex gap-2.5">
      {socialIconList.map(socialIcon => {
        return (
          <Link
            key={socialIcon.title}
            href={socialIcon.link}
            openInNewTab
            title={socialIcon.title}
            aria-label={socialIcon.title}
          >
            <SocialIconWrapper>
              <span className={classNames('rounded-sm', socialIcon.icon)} />
            </SocialIconWrapper>
          </Link>
        )
      })}
    </div>
  )
}

export default SocialIconsV2
